<template>
  <div class="Container">
    <div class="Login" v-if="displayLogin">
      <div class="Know-More">
        <div class="Title-Wrapper">
          <div class="Title">
            <div class="Title-Text">J'ai déjà un compte</div>
            <div class="Background" />
          </div>
        </div>
      </div>

      <input type="text" v-model="username" class="Input" :placeholder="$t('forms.email')" />
      <input type="password" v-model="password" class="Input" :placeholder="$t('forms.password')" />

      <div class="Submit" @click="submitLogin" v-if="!this.isLoading">
        {{ $t('forms.loginCta') }}
      </div>
      <div class="Loader-Wrapper" v-else>
        <loader />
      </div>
    </div>

    <div class="Splitter" v-if="displayLogin">
      <div class="hr" />
      <span class="Splitter-Text">{{ $t('shop.cartInformations.or') }}</span>
      <div class="hr" />
    </div>

    <div class="Register">
      <div class="Know-More">
        <div class="Title-Wrapper">
          <div class="Title">
            <div class="Title-Text">{{ $t('shop.cartInformations.noAccount') }}</div>
            <div class="Background" />
          </div>
        </div>
      </div>

      <input type="text" v-model="registerEmail" class="Input" :placeholder="$t('forms.email')" />

      <div v-if="!displayLogin" class="Register-fields">
        <div class="Password-container">
          <input type="password" v-model="registerPassword" class="Input Input-close" :placeholder="$t('forms.password')"/>
          <input type="password" v-model="confirm" class="Input Input-close" :placeholder="$t('forms.confirmPassword')"/>
        </div>

        <vv-form-mask-input
          id="birthday"
          label="birthday"
          name="birthday"
          v-model="birthday"
          required
          placeholder="JJ/MM/AAAA"
          :cleave="{ date: true, datePattern: ['d', 'm', 'Y'] }"
          :validate="'legalAge|date_format:dd/MM/yyyy'"
          :custom-class="'cartInformationsVariant'"
        />
      </div>

      <div class="Submit" @click="submitRegister" v-if="!this.isLoading">
        {{ $t('auth.register.callToAction') }}
      </div>
      <div class="Loader-Wrapper" v-else>
        <Loader />
      </div>
    </div>
  </div>
</template>

<script>
import { REGISTER_USER, SIGNIN_USER } from "@/store/modules/user/types";
import { SNACKBAR_MESSAGE } from "@/helpers/eventBus";
import * as types from "@/store/modules/user/types";
import VvFormMaskInput from "@/components/common/forms/VvFormMaskInput";
import user from "@/mixins/user";
import Loader from "@/components/common/Loader";

export default {
  name: 'AccountChecker',
  components: { Loader, VvFormMaskInput },
  mixins: [user],
  data: () => ({
    displayLogin: true,
    username: '',
    password: '',

    registerEmail: '',
    registerPassword: '',
    confirm: '',
    birthday: '',
    isLoading: false
  }),
  methods: {
    async submitLogin() {
      try {
        this.isLoading = true
        await this.login(this.username, this.password)
      } catch (error) {
        this.isLoading = false
      }
    },
    async submitRegister() {
      if (this.displayLogin) {
        this.displayLogin = false

        return
      }

      if (this.registerPassword !== this.confirm) {
        this.$eventBus.$emit(SNACKBAR_MESSAGE, {
          message: this.$t('errors.custom/password-mismatch')
        })
        return
      }

      if (!this.registerPassword.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*/) || this.registerPassword.length < 8) {
        this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/weak-password') })
        return
      }

      const result = await this.$validator.validateAll()

      if (!result) {
        return
      }

      this.isLoading = true

      // Register
      const [error, response] = await this.$store.dispatch(REGISTER_USER, {
        username: this.registerEmail,
        password: this.registerPassword,
        birthday: this.birthday,
      })

      if (error || response.data.error) {
        this.isLoading = false
        if (error && error.code) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code) })
        } else if (response.data.error) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.' + response.data.reason)
          })
        } else {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.custom/internal-error')
          })
        }
      } else {
        if (response.data.emailVerified) {
          // Force log the user
          await this.$store.dispatch(SIGNIN_USER, {
            username: this.username,
            password: this.password
          })
        } else {
          this.$store.commit(types.REGISTER_USER, { email: this.username, validated: false })

          this.$router.push({
            name: 'confirm-registration'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  display: flex;
  flex-direction: row;
  margin-top: 120px;
  justify-content: space-evenly;
  vertical-align: center;
  margin-bottom: 145px;

  @media (max-width: 450px) {
    flex-direction: column;
    margin-top: 40px;
    align-items: center;
  }

  .Login, .Register {
    width: 444px;
    display: flex;
    flex-direction: column;
    vertical-align: center;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 450px) {
      max-width: 80%;
    }

    .Register-fields {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @media (max-width: 450px) {
        max-width: 100%;
      }
    }

    .Input {
      height: 39px;
      margin-top: 45px;
      width: 444px;
      border: 2px solid #979a9a;

      @media (max-width: 450px) {
        max-width: 80%;
        margin-top: 20px;
      }
    }

    .Input-close {
      margin-top: 10px;

      @media (max-width: 450px) {
        margin-top: 5px;
      }
    }

    .Password-container {
      margin-top: 30px;

      @media (max-width: 450px) {
        max-width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    .Submit {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 29px;
      width: 300px;
      border-radius: 26px;
      background-color: $primary;
      text-align: center;
      color: white;
      height: 51px;
      font-weight: bold;
      font-size: 20px;
    }

    .Loader-Wrapper {
      margin-top: 29px;
    }
  }

  .Splitter {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $primary;

    @media (max-width: 450px) {
      flex-direction: row;
      flex-grow: 1;
      margin-left: 0;
      margin-right: 0;
      margin-top: 40px;
      margin-bottom: 40px;
      width: 80%;
    }

    &-Text {
      margin-top: 8px;
      margin-bottom: 8px;

      @media (max-width: 450px) {
        margin: 8px;
      }
    }

    .hr {
      border: 1px solid $primary;
      background-color: $primary;
      width: 1px;
      display: flex;
      flex-grow: 1;

      @media (max-width: 450px) {
        width: 100%;
      }
    }
  }

  .Know-More {
    margin-bottom: 40px;

    .Title-Wrapper {
      text-align: center;

      .Title {
        position: relative;
        display: inline-block;
        color: black;
        font-weight: bold;
        font-size: 28px;
      }

      .Title-Text {
        position: relative;
        z-index: 2;
      }

      .Background {
        content: '';
        display: block;
        height: 15px;
        width: 120%;
        position: absolute;
        bottom: -1px;
        left: -10%;
        z-index: 1 !important;
        background-color: #EDE6CA;
      }
    }
  }
}
</style>